import { ElementRef, Injectable } from '@angular/core';
import { continuousVisualizer } from 'sound-visualizer';
@Injectable({
  providedIn: 'root'
})
export class VoiceRecorderService {

  //PARA LA ONDA
  private visualizer?: { start: () => void; stop: () => void; reset: () => void };
  private canvasRef!: ElementRef<HTMLCanvasElement>;

  private mediaRecorder!: MediaRecorder;
  private chunks: Blob[] = [];
  private stream!: MediaStream;
  async startRecording(canvasRef: ElementRef<HTMLCanvasElement>) {
    this.canvasRef = canvasRef;
    this.stream = await navigator.mediaDevices.getUserMedia({ video: false, audio: true });
    this.mediaRecorder = new MediaRecorder(this.stream);

    this.chunks = [];
    this.mediaRecorder.ondataavailable = e => {
      if (e.data.size > 0) this.chunks.push(e.data);
    };

    this.mediaRecorder.start();
    this.initVisualizer();
  
  }

  private initVisualizer() {
    try {
      const canvasEl = this.canvasRef.nativeElement;
      this.visualizer = continuousVisualizer(this.stream, canvasEl,
        {
          // rectWidth: 'thin',           // grosor de línea (puede ser número o "thin"|"default"|"thick")
          strokeColor: "#007bff", // color de la onda
          // slices: 100,
          barRadius: 4
          // backgroundColor: "#f8f9fa" // color de fondo opcional
        }
      );
      this.visualizer.start();
    } catch (err) {
      console.error('Error al acceder al micrófono:', err);
    }
  }

  stopRecording(): Promise<Blob> {
    this.visualizer?.stop();
    return new Promise(resolve => {
      this.mediaRecorder.onstop = () => {
        const blob = new Blob(this.chunks, { type: 'audio/webm' });
        resolve(blob);
      };
      this.mediaRecorder.stop();
    });
  }

  pauseRecording(){
    
    this.mediaRecorder.pause();
    this.visualizer?.stop();
  }

  resumeRecording(){
    this.mediaRecorder.resume();
    // this.visualizer?.start();
    this.initVisualizer();
  }
}
